import { render, staticRenderFns } from "./OffersBody.vue?vue&type=template&id=d59357fe&scoped=true"
import script from "./OffersBody.vue?vue&type=script&lang=js"
export * from "./OffersBody.vue?vue&type=script&lang=js"
import style0 from "./OffersBody.vue?vue&type=style&index=0&id=d59357fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59357fe",
  null
  
)

export default component.exports